module.exports = __webpack_public_path__ + "static/media/Skjermbilde-C.d12c353b.png";